import { h } from 'preact'
import { Text } from 'preact-i18n'

export default ({title, options = [], onChange, selected}) =>
    <div class="limba__panel-attr">
        <h2><Text id={title} /></h2>
        <ul class="limba__type-picker">
            {options.map((option) =>
                <li class={"type " + (option.type == selected.type ? 'active' : '')} onClick={() => onChange(option)}><Text id={"mount.type." + option.type} /></li>
            )}
        </ul>
    </div>



// WEBPACK FOOTER //
// ./js/components/TypePicker.js